import { InjectionToken } from '@angular/core';
import { AuthModuleConfig } from '@portal-core/auth/models/auth-module-config.model';

export const AuthModuleConfigService = new InjectionToken<AuthModuleConfig>('AuthModuleConfig');
